import { render } from "./RoleManagement.vue?vue&type=template&id=2db3b694&scoped=true"
import script from "./RoleManagement.vue?vue&type=script&lang=js"
export * from "./RoleManagement.vue?vue&type=script&lang=js"

import "./RoleManagement.vue?vue&type=style&index=0&id=2db3b694&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2db3b694"

export default script